import axios, { AxiosResponse, AxiosError } from 'axios';
import { API_BASE_URL } from '../constants';

// Create axios instance
const httpClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'ngrok-skip-browser-warning': 'true',
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token and timezone to requests
httpClient.interceptors.request.use(
  config => {
    // Get token from localStorage (matches AuthService token key)
    const token = localStorage.getItem('aloAuthToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add browser's timezone to all requests
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['X-Timezone'] = timezone;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle global errors
httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    console.error('HTTP Error:', error);
    // Handle different types of errors globally
    if (error.response) {
      const { status, data, config } = error.response;

      switch (status) {
        case 401:
          // Unauthorized - redirect to login
          // Skip redirect for public RFP endpoints and public catalog endpoints
          if (
            !config?.url?.includes('/auth/login') &&
            !config?.url?.includes('hotels/rfp/') &&
            !config?.url?.includes('catalog/hotel-guide/')
          ) {
            localStorage.removeItem('aloAuthToken');
            localStorage.removeItem('user');
            window.location.href = '/login';
          }
          break;
        case 403:
          // Forbidden - store error message and redirect to 403 page
          const errorMessage =
            (data as any)?.message ||
            'You do not have permission to access this resource.';
          console.log('403 Error Message:', errorMessage);
          localStorage.setItem('forbiddenErrorMessage', errorMessage);

          window.location.href = '/403';
          // navigate('/403');
          break;
        case 404:
          // Not found - Allow forgot-password and reset-password to handle their own 404s
          if (
            !config?.url?.includes('/auth/forgot-password') &&
            !config?.url?.includes('/auth/reset-password')
          ) {
            console.error('Resource not found');
          }
          break;
        case 428:
          if ((data as any).requiresPasswordChange) {
            // Store email for change password page
            localStorage.setItem('changePasswordEmail', (data as any).email);
            window.location.href = '/change-password';
          }
          break;
        case 500:
          console.log('500 Server Error:', data);
          // Server error - redirect to error page
          window.location.href = '/500';
          break;
        default:
          console.error('An error occurred:', data);
      }
    } else if (error.request) {
      // Network error
      console.error('Network error - please check your connection');
    } else {
      // Something else happened
      console.error('Request failed:', error.message);
    }

    return Promise.reject(error);
  }
);

export default httpClient;
